import { createFileRoute, redirect } from '@tanstack/react-router';
import { GroupTypesSettings } from '@/components/companies/group-types-settings';
import { hasPermission } from '@/lib/permissions';

export const Route = createFileRoute(
  '/_auth/_side-layout/settings_/groups',
)({
  component: GroupTypesPage,
  beforeLoad: async ({ context }) => {
    if (!hasPermission(context.userRole, { organization: ['update'] })) {
      throw redirect({ to: '/' });
    }
  },
});

function GroupTypesPage() {
  return <GroupTypesSettings />;
}
